import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import type { IShowing } from 'src/api/landlord-showings-api';


type ICancelTourResponse = {
    tour: Omit<IShowing, 'start_date'> & { start_date: string };
};

export type ICancelTourPayload = {
    tourId: number;
    value: boolean
}

export const useCancelShowing = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<
        IShowing,
        IStandardErrorResponse,
        ICancelTourPayload
    >(
        async (payload) => {
            const res = await apiClient(`api/landlord/showings/${payload.tourId}/cancel`, {
                method: 'post',
                json: {
                    value: payload.value,
                },
            }).json<ICancelTourResponse>();
            return res.tour;
        }, {
            onSuccess: () => {
                addNotification('Tour updated', 'success');
                // The showings query key now includes the date window, so a
                // prefix invalidation refreshes every loaded window (a fixed-key
                // setQueryData would no longer match any cached query).
                queryClient.invalidateQueries(queryKeys.showings);
            }, onError: (error) => {
                const errorMessage = error.msg || 'Failed to update tour';
                addNotification(errorMessage, 'error');
            }
        });
};
